<template>
  <div class="props-group">
    <!-- <el-form-item label="列数">
      <el-input type="number" v-model="component.properties.numberOfColumns" :min="minColumns" max="32"/>
    </el-form-item> -->
    <el-form-item label="默认行数">
      <el-input type="number" v-model.number="component.properties.numberOfLines" :min="2" max="20"/>
    </el-form-item>
    <el-form-item label="最大显示行" prop="properties.maxNum" :rules="rules">
      <el-input type="number" v-model.number="component.properties.maxNum" :min="1" max="32" :disabled="maxLineEnable"/>
    </el-form-item>
    <el-form-item label-width="120px">
      <span slot="label">
        开启表单编辑&nbsp;
      <el-tooltip content="开启后将通过表单弹窗的方式来维护信息" placement="top" class="tooltip">
        <span class="fa fa-question-circle"></span>
      </el-tooltip>
      </span>
      <el-switch v-model="component.properties.enableEdit"></el-switch>
    </el-form-item>
    <el-form-item v-show="component.properties.enableEdit" label="选择表单" prop="properties.maxNum" :rules="rules">
      <el-select v-model="component.properties.selectForm" filterable @visible-change="getAllFormByColumnId" @change="getProperties">
        <el-option
          v-for="(item, index) in options"
          :title="item.name"
          :key="index"
          :label="item.name"
          :value="item.id">
        </el-option>
      </el-select>
    </el-form-item>
  </div>
</template>

<script>
export default {
  name: 'attr-max-row-module',
  props: ['component'],
  inject: ['formService'],
  data () {
    let numberValidator = function (rule, value, callback) {
      if (value !== '') {
        if (!Number.isInteger(value)) {
          callback(new Error('请输入整数'))
        } else {
          if (value < 0) {
            callback(new Error('请输入正数'))
          } else {
            callback()
          }
        }
      } else {
        callback(new Error('请输入最大行数'))
      }
    }
    return {
      maxLineEnable: false,
      rules: [
        { validator: numberValidator, trigger: 'blur' }
      ],
      options: [{name: '默认表单', id: '[默认表单]', properties: '{formScreen: "custom"}'}]
    }
  },
  computed: {
    minColumns () {
      return this.component.children.length || 1
    }
  },
  methods: {
    async getAllFormByColumnId (e) {
      e && await this.$axios.get(`/form-api/defines/findFormByArchivedId/${this.component.archive.tableId}`).then(res => {
        this.options = [...[{name: '默认表单', id: '[默认表单]', properties: '{formScreen: "custom"}'}], ...res.data]
      })
    },
    getProperties (id) {
      let value = this.options.find(e => e.id === id)
      this.component.properties.selectProperties = value.properties
    }
  },
  async created () {
    await this.getAllFormByColumnId(true)
  }
}

</script>

<style lang="scss">
  .props-group {
    .el-form-item {
      .el-form-item__label {
        .tooltip {
          color: #c2c3c4;

          &:hover {
            color: #409EFF;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/form/componentAttr/max-row-module.vue